import { createCookie } from "../../common/utils/cookieUtils";

export const initLanguageSwitcher = (): void => {
  const switchers = document.querySelectorAll<HTMLElement>(
    "[data-lang-switcher]"
  );

  switchers.forEach((switcher) => {
    const buttons =
      switcher.querySelectorAll<HTMLButtonElement>("[data-lang-code]");

    buttons.forEach((btn) => {
      btn.addEventListener("click", () => {
        const langCode = btn.dataset.langCode;

        if (langCode) {
          // 1. Set the cookie (Matches PHP LanguageManager expectation)
          createCookie("preferred_language", langCode, 365);

          // 2. Reload to apply language via PHP
          window.location.reload();
        }
      });
    });
  });

  console.log("[LanguageSwitcher] Vanilla JS initialized.");
};
